import { popupContentSlotClassNames } from '../../../../components/Popup/PopupContent';
export var menuButtonStyles = {
  root: function root() {
    return {
      boxSizing: 'border-box',
      display: 'inline-block'
    };
  },
  popupContent: function popupContent() {
    var _ref;

    return _ref = {}, _ref["& ." + popupContentSlotClassNames.content] = {
      borderWidth: '0px',
      padding: '0px'
    }, _ref;
  }
};